import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineZoomDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#F5F5F5"
      stroke="#B2B2B2"
      strokeWidth={1.5}
      d="M5.4 2.75h27.2c1.471 0 2.65 1.178 2.65 2.614V15.75a17 17 0 0 0-2.65-.204c-9.326 0-16.9 7.481-16.9 16.727 0 2.105.395 4.12 1.113 5.977H5.4c-1.471 0-2.65-1.177-2.65-2.613V5.364C2.75 3.928 3.93 2.75 5.4 2.75Z"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 11h13M9 18h5"
    />
    <path
      fill="#fff"
      d="M32.125 41.875c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M32.125 41.875c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75M45.125 45.125l-5.688-5.688"
    />
  </svg>
);
export default SvgStreamlineZoomDocument;
